import { Component, input } from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { SafePipe } from 'shared/pipes/safe.pipe';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

export interface PDFViewerData {
    pdfUrl: string;
    isPDF: boolean;
}

@Component({
    selector: 'ia-pdf-viewer',
    template: `
        <mat-card class="pdf-viewer">
            <mat-card-content class="pdf-content">
                @if (pdfData()?.isPDF) {
                    <ng2-pdfjs-viewer [pdfSrc]="pdfData()?.pdfUrl || ''"> </ng2-pdfjs-viewer>
                } @else {
                    <iframe [src]="pdfData()?.pdfUrl | safe: 'resourceUrl'" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
                }
            </mat-card-content>
        </mat-card>
    `,
    styles: [
        `
            .pdf-viewer {
                height: 100%;
                display: flex;
                flex-direction: column;
                border-radius: 0;
            }

            .pdf-content {
                padding-top: 0 !important;
                padding-left: 0 !important;
            }

            mat-card-content {
                flex: 1;
                overflow: hidden;
            }

            iframe {
                border: none;
            }
        `
    ],
    imports: [MatCardModule, SafePipe, PdfJsViewerModule]
})
export class AiIaPdfViewerComponent {
    pdfData = input<PDFViewerData>();
}
